import { useState } from "react";
import type { UpdateProfileFormTypes } from "../../types/admin/admin.form";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { updateProfile } from "../../redux/slices/adminSlice";
import { toast } from "react-toastify";
import { getErrorMessage } from "../../utils/errorHandler";
import buttonLoadingAnimation from "../../animations/buttonLoading.json";
import Lottie from "lottie-react";

export interface UpdateProfileProps {
  handleClose: () => void;
}

export const UpdateProfile = ({ handleClose }: UpdateProfileProps) => {
  const dispatch = useAppDispatch();
  const { admin } = useAppSelector((state) => state.admin);
  const [formData, setFormData] = useState<UpdateProfileFormTypes>({
    name: admin?.name ?? "",
    email: admin?.email ?? "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const [loading, setLoading] = useState<boolean>(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name && !formData.email) {
      toast.error("Cần cung cấp ít nhất 1 trường để cập nhật");
      return;
    }
    setLoading(true);
    try {
      await dispatch(updateProfile(formData)).unwrap();
      toast.success("Cập nhật hồ sơ thành công");
      handleClose();
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-3 z-50">
      <div className="p-5 bg-white rounded-lg w-full max-w-md space-y-2">
        <div className="flex items-center justify-center">
          <p className="text-lg font-semibold text-gray-700">
            Cập nhật hồ sơ
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-700">
              Tên
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="p-2 focus:outline-none focus:border-blue-500 transition-colors duration-300 border border-gray-200 rounded-xl w-full placeholder:text-sm placeholder:text-gray-400"
              placeholder="Nhập tên"
            />
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-700">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="p-2 focus:outline-none focus:border-blue-500 transition-colors duration-300 border border-gray-200 rounded-xl w-full placeholder:text-sm placeholder:text-gray-400"
              placeholder="Nhập email"
            />
          </div>
          <div className="flex items-center justify-between pt-2">
            <button
              type="button"
              onClick={handleClose}
              className="p-2 text-white text-sm bg-gray-500 hover:bg-gray-600 rounded-lg cursor-pointer"
            >
              Hủy
            </button>
            {loading ? (
              <Lottie
                animationData={buttonLoadingAnimation}
                loop={true}
                className="h-10 w-20"
              />
            ) : (
              <button
                type="submit"
                className="p-2 text-white text-sm bg-green-500 hover:bg-green-600 rounded-lg cursor-pointer"
              >
                Cập nhật
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};
